import { ajax } from '../utils';

var getAmateurRadioDetailedByCallsign = function getAmateurRadioDetailedByCallsign(callsignDB, callsign) {
  var result1 = callsignDB['1'].find(function (x) {
    return x.prefix === callsign.substring(0, 1);
  });
  var result2 = callsignDB['2'].find(function (x) {
    return x.prefix === callsign.substring(0, 2);
  });
  var result3 = callsignDB['3'].find(function (x) {
    return x.prefix === callsign.substring(0, 3);
  });
  var result4 = callsignDB['4'].find(function (x) {
    return x.prefix === callsign.substring(0, 4);
  });
  var result;

  if (result4 === undefined) {
    if (result3 === undefined) {
      if (result2 === undefined) {
        if (result1 === undefined) {
          result = undefined;
        } else {
          result = result1;
        }
      } else {
        result = result2;
      }
    } else {
      result = result3;
    }
  } else {
    result = result4;
  }

  return result;
};

var asyncGetAmateurRadioDetailedByCallsign = function asyncGetAmateurRadioDetailedByCallsign(callsign, url) {
  if (typeof callsign !== 'string') {
    console.error('[callsign.js]: Callsign must be string');
    return;
  }

  callsign = callsign.toUpperCase();

  if (url === undefined) {
    url = 'https://unpkg.com/callsign/dist/data/cty.json';
  }

  return new Promise(function (resolve, reject) {
    ajax('GET', url).then(function (res) {
      var getDetail = getAmateurRadioDetailedByCallsign(JSON.parse(res), callsign);
      resolve(getDetail);
    })["catch"](function (e) {
      reject('[callsign.js]: Network Error');
    });
  });
};

export default asyncGetAmateurRadioDetailedByCallsign;